class videoWrapper extends HTMLElement {
  constructor() {
    super()
    this.media = 'only screen and (min-width: 768px)';
    this.dataSelectors = {
      desktop: 'data-desktop-src',
      mobile: 'data-mobile-src',
      all: 'data-src'
    };
  }
  connectedCallback() {
    this.checkVideos()
  }

  checkVideos() {
    setTimeout(() => {
      if (window.matchMedia(this.media).matches) {
        this.replaceSrc(this.dataSelectors.desktop)
      } else {
        this.replaceSrc(this.dataSelectors.mobile)
      }
    }, 250)
  }

  replaceSrc(data) {
    let srcItem;
    let selectorData = data;
    if (this.querySelector(`[${data}]`)) {
      srcItem = this.querySelector(`[${data}]`)
    } else {
      srcItem = this.querySelector(`[${this.dataSelectors.all}]`)
      selectorData = this.dataSelectors.all;
    }
    srcItem.src = srcItem.getAttribute(selectorData)
    srcItem.removeAttribute(selectorData)
    const videoItem = srcItem.closest('video')
    videoItem.load()
  }

}
customElements.define('video-wrapper', videoWrapper)
